import { Component } from '@angular/core';

@Component({
  templateUrl: './thematic-portfolios.component.html',
  styleUrls: ['../../shared/static-pages.scss'],
  standalone: false
})
export class ThematicPortfoliosComponent { }
